<select [ngClass]="{'input-default': inputStyle === 'default', 'input-rounded': inputStyle === 'rounded'}"
        [ngStyle]="{'font-size': inputSize}" class="form-control form-select {{customClass}}" [id]="liveSearchId"
        [multiple]="multiple" (change)="change($event)"
>
  <option *ngIf="!multiple" value>{{ placeholder }}</option>
  <option *ngFor="let option of options" [value]="option.value" [selected]="selectedValue==option.value">
    {{ option.label }}
  </option>
</select>
